import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import * as moment from 'moment';
import { SubjectService } from 'src/app/services/subject.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { LanguageSwitchService } from 'src/app/services/language-switch.service';
import { TranslateService } from '@ngx-translate/core';
import { PaymentInfoService } from 'src/app/services/payment-info.service';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { TrackRequestService } from 'src/app/services/track-request.service';
@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit {
  @Input() flow: string = ''
  currentLanguage: string = '';
  preferredNumberMessage: any;
  sku: any;
  transactionId: any;
  mobileNumber: any;
  billType: any;
  price: any;
  email: any;
  userInfo: any;
  isNavCollapsed = true;
  isVisitorLine: boolean;
  cart: any;
  paymentMethod: any = '';
  trackReqData: any = {};
  from:any;
  constructor(
    private modalController: ModalController,
    private UTS: UtilitiesService,
    private SKUDS: SkuDataService,
    private SS: SubjectService,
    private aRoute:ActivatedRoute,
    private GAS: GoogleAnalyticsService,
    private AAS: AdobeAnalyticsService,
    private LSS: LanguageSwitchService,
    public translate: TranslateService,
    private payment: PaymentInfoService,
    private route:Router, 
    private TRS: TrackRequestService,

  ) {
    this.aRoute.queryParams.subscribe((q)=>{
      if(q && q.orderId){
        this.transactionId = q.orderId;
      }
      if(q && q.from){
        this.from = q.from;
      }
      if(q && q.email){
        this.email = q.email;
      }
      if(q && q.flow){
        this.flow = q.flow
      }
      // this.flow = localStorage.getItem('flow');
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if(this.userInfo){
        this.email = this.userInfo.email;
      }
      if(localStorage.getItem('flow')){
        localStorage.removeItem('flow');
      }

      if (
        (q && q.lang && q.lang.toLowerCase() == 'ar') ||
        (q && q.locale && q.locale.toLowerCase() == 'ar')
      ) {
        this.LSS.setLanguage(
          q.locale
            ? q.locale.toLowerCase()
            : q.lang
            ? q.lang.toLowerCase()
            : 'ar'
        );
        
        this.translate.setDefaultLang('ar');
      } else if (
        (q && q.lang && q.lang.toLowerCase() == 'en') ||
        (q && q.locale && q.locale.toLowerCase() == 'en')
      ) {
        this.LSS.setLanguage(
          q.locale
            ? q.locale.toLowerCase()
            : q.lang
            ? q.lang.toLowerCase()
            : 'en'
        );
        this.translate.setDefaultLang('en');
      } else {
        this.LSS.setLanguage(
          this.UTS.getLocaleLanguage().toLocaleLowerCase()
        );
        this.translate.setDefaultLang('en');
      }
    })
    this.currentLanguage = this.UTS.getLocaleLanguage();

  }

  ngOnInit() {
    this.currentLanguage = this.UTS.getLocaleLanguage();
    this.trackReqData = JSON.parse(localStorage.getItem('TR'));
    const visitorlineDetails = JSON.parse(localStorage.getItem('visitorlineDetails'))
    this.isVisitorLine = false;
    if(visitorlineDetails){
      this.isVisitorLine = true;
      localStorage.removeItem('visitorlineDetails')
      this.email = visitorlineDetails.visitorDetail.email
    }
    this.paymentMethod = localStorage.getItem('paymentMethod')
    let paymentId = sessionStorage.getItem('paymentId');
    let CQAcceptDateTime = localStorage.getItem('CQAcceptDateTime');

    // if (!CQAcceptDateTime) {
    //     CQAcceptDateTime = new Date().toISOString();
    //     localStorage.setItem('CQAcceptDateTime', CQAcceptDateTime);
    // }
      if (CQAcceptDateTime && paymentId) {
        const payload = {
          category: "trackCQ",
          cqReferenceNo: this.trackReqData?.cqReferenceNo,
          operationType: 'updateCQ',
          paymentId,
          CQAcceptDateTime,
        };
        this.TRS.handleCQOperations(payload).subscribe(
          (r: any) => {
            if (r && r.success) {
              console.log('success:', r);
            } 
          },
          (error) => {
            console.error('error:', error);
          }
        );
      } else {
        console.log('CQAcceptDateTime not found in localStorage.');
      }
  
    // if( this.paymentMethod == 'newCreditDebtCard' ||
    //     this.paymentMethod == 'creditDebtCard' || 
    //     this.paymentMethod == 'bankTransfer' ) {
    //     this.finalizePayment()
    //     }
  }
  ok() {
    this.dismiss();
  }

  cancel() {
    this.dismiss();
  }

  closePopUpEN() {
    this.dismiss();
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    // this.modalController.dismiss({
    //   dismissed: true,
    // });
    
    window.location.href = environment.HOST + '/b2c/eshop/userOrdersTracking';
  }

  letGoPopUpLinkEN() {
    const browserName = this.getBrowserInfo();

    var feedbackHost =
      'https://feedback.etisalat.ae/collection/collection.aspx?cguid=9e4-b515de8da5e0&langid=1&sessionCustomText5=&sessionCustomText6=&consumerAccount=&sessionCustomText8=' +
      browserName +
      '&sessionCustomText9=WEB';
    window.open(feedbackHost, '_blank');
  }

  closePopUpAR() {
    this.dismiss();
  }

  letGoPopUpLinkAR() {
    const browserName = this.getBrowserInfo();

    const feedbackHost =
      'https://feedback.etisalat.ae/collection/collection.aspx?cguid=9e4-b515de8da5e0&langid=22&sessionCustomText5=&sessionCustomText6=&consumerAccount=&sessionCustomText8=' +
      browserName +
      '&sessionCustomText9=WEB';
    window.open(feedbackHost, '_blank');
  }

  getBrowserInfo() {
    const nVer = navigator.appVersion;
    const nAgt = navigator.userAgent;
    let browserName = navigator.appName;
    let fullVersion = '' + parseFloat(navigator.appVersion);
    let majorVersion = parseInt(navigator.appVersion, 10);
    let nameOffset, verOffset, ix;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf('Opera')) != -1) {
      browserName = 'Opera';
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
      browserName = 'Microsoft Internet Explorer';
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
      browserName = 'Chrome';
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
      browserName = 'Safari';
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
      browserName = 'Firefox';
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if (
      (nameOffset = nAgt.lastIndexOf(' ') + 1) <
      (verOffset = nAgt.lastIndexOf('/'))
    ) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }

    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) != -1)
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(' ')) != -1)
      fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = '' + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }

    return browserName;
  }

  getValidity(v: any) {
    if (v) {
      return v == 'Monthly' ? ' 1 Month ' : v == 'Weekly' ? '1 Week' : '1 Day';
    }
    return v;
  }
  today() {
    const lang = this.UTS.getLocaleLanguage();
    if (lang == 'ar') {
      moment.locale('ar-tn');
      return moment(Date.now()).format('Do MMM, YYYY');
    } else {
      moment.locale('en');
      return moment(Date.now()).format('Do MMM, YYYY'); // 13th April, 2020
    }
  }

  changeLangAction(){}

  finalizePayment(){
    this.payment.finalizePayment().subscribe(() => {
      // if(resp && resp.transactionId){
        // this.UpdatePayment(resp.transactionId)
      // }
    })
  }

  backToHome(){
    this.route.navigate(['/track-request?locale='+this.currentLanguage])
  }
  
  uploadPaymentReceipt(){
    this.route.navigateByUrl('/track-request/upload-payment?locale='+this.currentLanguage)
  }
  
  locateStore(){
   window.location.href = 'https://www.etisalat.ae/en/storelocator.html';
  }

  gotoTrackRequest(){
    const url = '/track-request/search?locale='+this.currentLanguage
    this.route.navigateByUrl(url);
  }

  cqPortal(){
    this.route.navigate(['/home?locale='+this.currentLanguage]);
  }
}
